import type { Locale } from '@change-corgi/config/locales';

import __help from '../config/help.json';

export const helpLocales: Partial<Record<Locale, string>> = __help.localeMapping;

export const helpCountryLegalHelpUrls: Partial<Record<string, string>> = __help.legalHelpUrls;

export const helpCountryLegalUrls: Partial<Record<string, string>> = __help.legalUrls;
